import siteLaunchTheme from './siteLaunchTheme';
var siteLaunchDarkTheme = {
  siteLaunch: Object.assign({}, siteLaunchTheme.siteLaunch, {
    bgStart: '#1a1a1a',
    bgEnd: '#1a1a1a'
  })
};
export default siteLaunchDarkTheme;